import { ExternalRmaIntegration } from "@redotech/redo-return-core-common/integrations/returns/Integrations";
import * as z from "zod";

/** The integration whose RMA function the call is about. */
const integration = z.enum(ExternalRmaIntegration);

/**
 * Codes on the RMA function RPCs' errors, which clients translate. A failed
 * save test is `test_failed.<stage>`, with the technical details as the
 * message.
 */
export const RmaFunctionErrorCode = {
  NOT_FOUND: "rma_function_not_found",
  ARTIFACT_NOT_FOUND: "rma_function_artifact_not_found",
  NOT_DEPLOYED: "rma_function_not_deployed",
  TEST_FAILED: "rma_function_test_failed",
} as const;

export const getRmaFunction = {
  name: "getRmaFunction" as const,
  input: z.object({ integration }),
  output: z.discriminatedUnion("available", [
    z.object({ available: z.literal(false) }),
    z.object({
      available: z.literal(true),
      integrationId: z.string(),
      contractId: z.string(),
      /** Who receives the RMA, for the integration's current provider. */
      displayName: z.string(),
      enabled: z.boolean(),
      artifactId: z.string().optional(),
      deployedAt: z.date().optional(),
      deployedBy: z.string().optional(),
    }),
  ]),
};

export const testRmaFunction = {
  name: "testRmaFunction" as const,
  input: z.object({
    integration,
    code: z.string(),
    /** Defaults to the contract's sample input. */
    input: z.unknown().optional(),
  }),
  output: z.object({
    ok: z.boolean(),
    logs: z.string(),
    output: z.unknown().optional(),
    error: z
      .object({
        stage: z.string(),
        message: z.string(),
        code: z.string().optional(),
      })
      .optional(),
    violations: z.array(z.object({ reason: z.string(), path: z.string() })),
  }),
};

export const saveRmaFunction = {
  name: "saveRmaFunction" as const,
  input: z.object({ integration, artifactId: z.string() }),
  output: z.object({}),
};

export const setRmaFunctionEnabled = {
  name: "setRmaFunctionEnabled" as const,
  input: z.object({ integration, enabled: z.boolean() }),
  output: z.object({}),
};
